import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { formatAddDots } from '@/utils/format-add-dots'

interface IndicatorsTooltipProps {
  totalAreaPreserved: number
  children: React.ReactNode
}

export function IndicatorsTooltip({
  totalAreaPreserved,
  children,
}: IndicatorsTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>{children}</TooltipTrigger>

        <TooltipContent
          className="text-lg font-semibold text-bios-secondary"
          data-wg-notranslate
        >
          {formatAddDots(totalAreaPreserved)}
          <span className="text-sm font-normal">ha</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
